// Copyright 2024, Imprivata, Inc.  All rights reserved.

import type { TraceContext } from '@imprivata-cloud/common/types';
import { addSpanAttributes } from '@imprivata-cloud/common';
import type { SessionData, SessionDataKey } from '../../agent-api/types';
import type { MemorySection } from './MemorySection';

export class SessionSection {
  constructor(private readonly _memory: MemorySection) {}

  getData(
    workflowId: string,
    _traceContext: TraceContext,
    keys: SessionDataKey[],
    callback: (sessionData: SessionData) => void,
  ) {
    addSpanAttributes({
      get_session_data: {
        workflowId,
        keys,
      },
    });
    callback(this._memory.sessionData);
  }

  setData(_: string, _traceContext: TraceContext, sessionData: SessionData) {
    this._memory.sessionData = sessionData;
  }
}
